import AOS from 'aos';

export function init() {
    AOS.init({});
}

export default AOS;
